import React from "react";
import './ProductsContainer.css';
import {useSelector} from "react-redux";
import ProductCard from "../ProductCard/ProductCard";

const ProductsContainer = () => {
  const products = useSelector(state => state.products);
  const prevProducts = useSelector(state => state.prevProducts);
  const imgPrefix = useSelector(state => state.imgPrefix)

  return (
    <div className="products-container">
      {products
        .filter((el) => typeof (el.value) != 'function')
        .map((el, index) =>
          el && el.data
            ? <ProductCard
              value={el}
              index={index}
              key={'product_' + index}
              id={'accelasearch_product_' + (index + 1)}
              prevValue={prevProducts[index]}
              imgPrefix={imgPrefix}
            />
            : null
        )
      }
    </div>
  )
};

export default ProductsContainer;
